var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
        }
      }),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("AprobarRRHHSinPermisos"),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-text",
            { staticClass: "p-0" },
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("span", { staticClass: "material-symbols-outlined" }, [
                      _vm._v(" leaderboard ")
                    ]),
                    _vm._v("\n          Reporte de permisos \n        ")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "p-0",
                          staticStyle: { "min-width": "100%" },
                          attrs: { "grid-list-md": "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha inicio",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_inicio,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_inicio", $$v)
                                      },
                                      expression: "form.fecha_inicio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      type: "date",
                                      label: "Fecha fin",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_fin,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_fin", $$v)
                                      },
                                      expression: "form.fecha_fin"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.tipo_permisos,
                                      "item-value": "descripcion",
                                      "item-text": "descripcion",
                                      label: "Seleccionar tipo de permiso",
                                      outline: ""
                                    },
                                    model: {
                                      value: _vm.form.id_tipo_permiso,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_tipo_permiso",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_tipo_permiso"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.unidades_generales,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad general",
                                      outline: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_general,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_general",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_general"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.unidades_especificas,
                                      "item-value": "id_unidad",
                                      "item-text": "nombre_unidad",
                                      label: "Unidad especifica",
                                      maxlength: "50",
                                      outline: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_unidad_especifica,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "id_unidad_especifica",
                                          $$v
                                        )
                                      },
                                      expression: "form.id_unidad_especifica"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Número",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.numero,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "numero", $$v)
                                      },
                                      expression: "form.numero"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.estados,
                                      "item-value": "id",
                                      "item-text": "descripcion",
                                      label: "Estado",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.id_estado,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_estado", $$v)
                                      },
                                      expression: "form.id_estado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Hora desde",
                                      type: "time",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "hora_desde", $$v)
                                      },
                                      expression: "form.hora_desde"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Hora hasta",
                                      type: "time",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.hora_hasta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "hora_hasta", $$v)
                                      },
                                      expression: "form.hora_hasta"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Paterno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.paterno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "paterno", $$v)
                                      },
                                      expression: "form.paterno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Materno",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.materno,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "materno", $$v)
                                      },
                                      expression: "form.materno"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Nombres",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.nombres,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "nombres", $$v)
                                      },
                                      expression: "form.nombres"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Cédula de identidad",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.ci,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "ci", $$v)
                                      },
                                      expression: "form.ci"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      label: "Item",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios(
                                          _vm.form.fecha_inicio,
                                          _vm.form.fecha_fin
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.item,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "item", $$v)
                                      },
                                      expression: "form.item"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "py-0",
                                  attrs: { xs12: "", sm6: "", md4: "" }
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "text-field-reducido",
                                    attrs: {
                                      items: _vm.entregados,
                                      "item-value": "id",
                                      "item-text": "entregado",
                                      label: "Estado entregado",
                                      outline: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.obtenerListaFuncionarios()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.entregado,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "entregado", $$v)
                                      },
                                      expression: "form.entregado"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                disabled: !_vm.bandera_boton_buscar,
                                color: "rgba(31,14,180,0.3)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.obtenerListaFuncionarios(
                                    _vm.form.fecha_inicio,
                                    _vm.form.fecha_fin
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("\n              Buscar\n            ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "rgba(158,11,127,0.6)",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.limpiarCampos()
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("redo")]),
                              _vm._v("\n              Limpiar\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_funcionarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros de permisos",
                  "disable-initial-sort": true,
                  loading: _vm.loading,
                  "no-results-text": "No se encontraron coincidencias"
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.numero) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.uni) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nom) +
                              " " +
                              _vm._s(props.item.pat) +
                              " " +
                              _vm._s(props.item.mat) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.cargo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.permiso) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.estado) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_permiso
                                  ? _vm
                                      .$moment(props.item.fecha_permiso)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_desde
                                  ? _vm
                                      .$moment(props.item.fecha_desde)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.fecha_hasta
                                  ? _vm
                                      .$moment(props.item.fecha_hasta)
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.hora_desde
                                  ? _vm
                                      .$moment(
                                        props.item.hora_desde,
                                        "HH:mm:ss"
                                      )
                                      .format("HH:mm")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.hora_hasta
                                  ? _vm
                                      .$moment(
                                        props.item.hora_hasta,
                                        "HH:mm:ss"
                                      )
                                      .format("HH:mm")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#006A8E",
                                  icon: "",
                                  title: "Ver seguimiento",
                                  outline: ""
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verSeguimientoPermiso(props.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("visibility")])],
                              1
                            ),
                            _vm._v(" "),
                            (props.item.id_estado == 6 ||
                              props.item.id_estado == 21) &&
                            props.item.id_tipo_permiso != 24
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "rgb(80,38,217)",
                                      icon: "",
                                      title: "Aprobar permiso",
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.aprobarPermiso(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("done")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.ruta_archivo
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#F58736",
                                      icon: "",
                                      title: "Ver documento adjunto",
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verDocumento(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("description")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.id_tipo_permiso != 95 &&
                            props.item.id_tipo_permiso != 90 &&
                            props.item.id_tipo_permiso != 18 &&
                            props.item.id_tipo_permiso != 89 &&
                            props.item.id_tipo_permiso != 98 &&
                            props.item.id_tipo_permiso != 99 &&
                            props.item.id_tipo_permiso != 8 &&
                            props.item.id_tipo_permiso != 100 &&
                            props.item.id_tipo_permiso != 101 &&
                            (props.item.id_estado == 7 ||
                              props.item.id_estado == 6 ||
                              props.item.id_estado == 21 ||
                              props.item.id_estado == 77)
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#F58736",
                                      icon: "",
                                      title: "Ver reporte"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verReporte(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f2376d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f2376d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/ReportePermisos.vue
// module id = null
// module chunks = 